<template>
  <RevCard class="flex flex-col gap-24 p-24" data-cs-mask>
    <div class="grow">
      <Address
        :address="billingAddress"
        compact
        with-details
        :with-phone="false"
      >
        <template #title="{ fullName }">
          {{ i18n(translations.billTo, { fullName }) }}
        </template>
      </Address>
    </div>

    <RevButton size="small" variant="secondary" @click="handleModify">
      {{ i18n(translations.modify) }}
    </RevButton>
  </RevCard>
</template>

<script setup lang="ts">
import { navigateTo } from '#imports'

import type { Bill } from '@backmarket/http-api/src/api-specs-checkout/cart/cart.types'
import Address from '@backmarket/nuxt-module-address/Address.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'

import { CHECKOUT } from '~/scopes/checkout/routes-names'

import translations from './BillingAddressSummary.translations'

defineProps<{
  billingAddress: Bill
}>()

const i18n = useI18n()

function handleModify() {
  navigateTo({ name: CHECKOUT.GIFT_CARDS.BILLING_ADDRESS })
}
</script>
